import { Spinner } from './Spinner';

interface LoadingStateProps {
  message?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  minHeight?: string;
}

export function LoadingState({
  message = 'Loading...',
  className = '',
  size = 'md',
  minHeight = 'min-h-[200px]',
}: LoadingStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center space-y-4 p-4 text-center ${minHeight} ${className}`}
    >
      <Spinner size={size} className="text-primary-600" />
      {message && (
        <p className="text-sm font-medium text-gray-600">{message}</p>
      )}
    </div>
  );
}
